import React from "react";
import { storeContext } from "../store";

const useStores = () => React.useContext(storeContext);

export default useStores;
